export const DELETE_DEPARTMENT = "DELETE_DEPARTMENT";
export const deleteDepartmentsAction = (depatment) => {
  return {
    type: "DELETE_DEPARTMENT",
    payload: depatment,
  };
};

export const FETCH_DEPARTMENT = "FETCH_DEPARTMENT";
export const fetchDepartmentsAction = (depatment) => {
  return {
    type: "FETCH_DEPARTMENT",
    payload: depatment,
  };
};

export const INIT_DEPARTMENT = "INIT_DEPARTMENT";
export const initDepartmentsAction = () => {
  return {
    type: "INIT_DEPARTMENT",
    payload: null,
  };
};
